<template>
  <section class="tile tile-noshrink" :class="item.type" role="group" :aria-labelledby="id">
    <div class="tile-box">
      <div class="row">
        <div class="col-l-8 col-xs-12">
          <div class="logo_container"><img v-if="item.hasImage" :src="getImageLocation" alt="" aria-hidden="true" class="logo"/></div>
        </div>
        <div class="col-l-4 col-xs-12">
          <img v-if="readOnly" :src="lockUnlockSymbol" :alt="symbolTooltip" width="50" height="50" style="float: right; vertical-align: middle;" />
          <button
            v-else
            type="button"
            class="btn btn-default pull-right"
            style="padding-top: 10px; padding-bottom: 10px;"
            :title="symbolTooltip"
            @click="onToggle"
          >
            <img :src="lockUnlockSymbol" :alt="symbolTooltip" width="50" height="50" style="vertical-align: middle" />
            <span class="sr-only">{{ $t('barring.toggleNotice') }}</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-l-12">
          <span class="h4">
            <small>{{ $t('barring.type_' + item.type) }}</small>
          </span>
          <h3 v-if="item.type === 'category'" :id="id" v-html="$tm('barring.contentTypeCode_', item.name)" />
          <h3 v-else :id="id" v-html="item.name" />
        </div>
      </div>
      <div class="tile-row">
        <div class="tile-cell" style="padding-bottom: 6px">
          <div class="col-m-6">
            <div
              v-if="(item.type === 'voiceFactoring' || item.type === 'category') && item.items && item.items.length > 0 && !item.hasExceptions && !readOnly"
              class="exceptions"
            >
              <button
                type="button"
                class="btn btn-default btn-small"
                style="margin-top: -2px"
                :title="$t('barring.tooltipBtnDefineExceptions')"
                @click="onOpenExceptions"
                >{{ $t('barring.btnDefineExceptions') }}</button
              >
            </div>
            <div
              v-if="(item.type === 'voiceFactoring' || item.type === 'category') && item.items && item.items.length > 0 && item.hasExceptions && readOnly"
              class="exceptions"
            >
              <button
                type="button"
                class="btn btn-default btn-small"
                style="margin-top: -2px"
                :title="$t('barring.tooltipBtnDefineExceptions')"
                @click="onOpenExceptions"
                >{{ $t('barring.btnShowExceptions') }}</button
              >
            </div>
          </div>
          <div class="col-m-6 pull-right">
            <button
              v-if="item.type === 'factoring' || item.type === 'voiceFactoring' || item.type === 'category'"
              class="info-button pull-right"
              @click="onOpenDetails"
            >
              <span class="sr-only">{{ $t('barring.tooltipBtnDetails') }}</span>
              <img
                src="@/assets/images/barring/information_graphical.svg"
                width="30"
                height="30"
                alt=""
                aria-hidden="true"
                :title="$t('barring.tooltipBtnDetails')"
              />
            </button>
          </div>
        </div>
      </div>
      <VInfo v-if="modalInfo" v-bind="modalInfo" @close="modalInfo = null" />
    </div>
  </section>
</template>

<script>
import filter from 'lodash/filter';
import VInfo from '@/components/Barring/Info';

export default {
  name: 'PartnerSelectionItem',

  components: {
    VInfo,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      modalInfo: null,
      id: Math.random()
        .toString(36)
        .substring(2),
    };
  },

  computed: {
    lockUnlockSymbol() {
      if (this.item.hasExceptions) return require('@/assets/images/barring/status-solid-exceptions.svg');
      return require(`@/assets/images/barring/status-solid-` + (this.item.isBarred ? 'lock' : 'unlock') + `.svg`);
    },

    symbolTooltip() {
      if (this.item.hasExceptions) return this.$t('barring.tooltipHasExceptions');
      return this.$t(this.appendType('barring.tooltip' + (this.item.isBarred ? 'IsBarred' : 'IsUnbarred')));
    },

    getImageLocation() {
      return `delegates/barring/content/${this.item.type === 'category' ? 'categories' : 'businesspartner'}/${this.getName(this.item.partnerId)}`;
    },
  },

  methods: {
    getName(name) {
      return name.replace('.', '_');
    },

    onToggle() {
      if (this.item.hasExceptions) {
        this.onOpenExceptions();
      } else {
        this.$emit('toggle', this.item);
      }
    },

    onOpenDetails() {
      this.modalInfo = this.item;
    },

    onOpenExceptions() {
      this.$emit('open:exceptions', this.item);
    },

    appendType(base) {
      return filter([base, this.getType]).join('_');
    },
  },

  inject: ['getType', 'readOnly'],
};
</script>

<style scoped>
.logo_container {
  height: 60px;
}
.logo {
  max-height: 60px;
}
h3 {
  margin-top: 0;
}
h4 {
  margin-top: 0;
}
.tile {
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
}
.aligncontent .tile {
  margin-bottom: 36px;
}

.info-button {
  padding: 0;
  background: transparent;
  border: none;
}
</style>
